import request from '@/axios'

export function fetchQuestionBank (platform_customer_id, payload, page, query = {}) {
  let url = ''
  if (Object.keys(query).length === 0 && query.constructor === Object) {
    url = `/question-bank/get/${platform_customer_id}?page=${page}`
  } else {
    url = `/question-bank/get/${platform_customer_id}?attribute=${query.attribute}&direction=${query.direction}&field_type=${query.field_type}&page=${page}`
  }
  return request({
    url,
    method:'POST',
    data:payload
  })
}


export function createQuestionBank (payload, platform_customer_id) {
  return request({
    url:`/question-bank/create/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}

export function editQuestionBank (payload, platform_customer_id) {
  return request({
    url:`/question-bank/create/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}

export function deleteQuestionById (platform_customer_id, payload) {
  return request({
    url:`/question-bank/delete/${platform_customer_id}`,
    method:'POST',
    data:payload

  })
}

export function changeQuestionStatusById (platform_customer_id, payload) {
  return request({
    url:`/question-bank/change-status/${platform_customer_id}`,

    method:'POST',
    data:payload

  })
}

export function questionShare (platform_customer_id, payload) {
  //http://localhost:8000/api/assignment-builder/share/2
  return request({
    url:`/question-bank/share/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}

export function questionBankFetch (platform_customer_id, question_bank_id) {
  return request({
    url:`/question-bank/get/${platform_customer_id}/${question_bank_id}`,
    method:'POST'
  })
}

